<div class="container-fluid px-0">
    <div class="row">
        <div class="col-xl-12">
            <div class="card h-100">
                <div class="card-header">
                    <!-- toolbar -->

                    <div class="btn-group shadow-lg" style="border-radius: 10px;">
                        <button class="btn" (click)="cambiarMes(-1)">
                            <i class="fas fa-chevron-left"></i> Anterior
                        </button>
                        <span class="btn">{{ obtenerNombreMes(mesActual.getMonth()) | uppercase }}</span>
                        <button class="btn" (click)="cambiarMes(1)">
                            Siguiente <i class="fas fa-chevron-right"></i>
                        </button>
                    </div>

                </div>
                <div class="card-body">
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                        (pageChange)="search()"></ngb-pagination>
                    <div class="table-responsive">
                        <table class="table user-list">
                            <thead>
                                <tr>
                                    <th><span>HORARIO</span></th>
                                    <th><span>TIPO DE RONDA</span></th>
                                    <th><span>CUMPLIMIENTO</span></th>
                                </tr>
                            </thead>
                            <tbody *ngIf="items?.length>0; else noData">
                                <tr *ngFor="let item of items">
                                    <td>
                                        <i class="fa-regular fa-clock"></i>
                                        <small>
                                            {{item?.start_date | date:' HH:mm-dd/MM/y'}} </small>
                                        <b *ngIf="item?.rounds_type_id!=3"> - </b>
                                        <small *ngIf="item?.rounds_type_id!=3">
                                            {{item?.end_date | date:' HH:mm-dd/MM/y'}}</small>

                                    </td>
                                    <td>

                                        <small class="badge"
                                            [ngClass]="{'bg-primary': item?.rounds_type?.id == 1, 'bg-success': item?.rounds_type?.id == 2,'bg-warning': item?.rounds_type?.id == 3}">
                                            {{item?.rounds_type?.tag}}</small><br>


                                    </td>
                                    <td>
                                        <div>
                                            <div class="card card-body shadow-sm p-1 m-1"
                                                *ngFor="let sitem of item?.rounds_records">
                                                <!-- Detalle de la ronda -->
                                                <small>
                                                    <i *ngIf="sitem?.status_id==1"
                                                        class="fa-solid fa-circle-check text-success me-1"></i>
                                                    <i *ngIf="sitem?.status_id==0"
                                                        class="fa-solid fa-ban text-danger"></i>
                                                    <i class="fas fa-map-marker-alt ms-1"></i> {{
                                                    sitem?.rounds_tags?.location
                                                    || " Sin ubicación" }}
                                                    <i *ngIf="sitem?.status_id==1" class="far fa-clock ms-1"></i>{{
                                                    sitem?.update_in }}
                                                    <i *ngIf="sitem?.status_id==1"
                                                        class="fa-solid fa-person-military-pointing ms-1"></i>{{
                                                    sitem?.guards?.name }} {{ sitem?.guards?.lastname }} <span class="badge ms-1" *ngIf="sitem?.guards?.position_name" [style.background]="sitem?.guards.position_color || '#6c757d'">{{ sitem?.guards.position_name | uppercase }}</span>
                                                    <span *ngIf="sitem?.obs"><b>Observación: </b>{{sitem?.obs}}</span>
                                                </small>
                                            </div>

                                        </div>
                                    </td>


                                </tr>

                            </tbody>
                            <ng-template #noData>
                                <tbody>
                                    <td colspan="7" class="fw-lighter text-muted">No se encontraron Registros</td>
                                </tbody>
                            </ng-template>
                        </table>
                    </div>
                    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
                        (pageChange)="search()"></ngb-pagination>
                </div>
            </div>
        </div>
    </div>

</div>
<ng-template #searchRut let-c="close" let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-search-record (selected)="d('Cross click')" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>